import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import { ImgClick } from '../../utility';
import AnimationWithSound from '../AnimationWithSound';
import { useSelector } from 'react-redux';

export const STAGE_STAGE = {
  notDisplayed: 0,
  locked: 1,
  unlocking: 2,
  unlocked: 3,
  bossAppealing: 4,
};

const MainStage = ({
  number,
  stageState,
  unlocked,
  locked,
  unlocking,
  handleOnClick,
}) => {
  const { images } = useImagesContext();
  const config = useSelector((state) => state.config);
  // console.debug(`Rendering Stage ${number} with state:`, stageState);
  return (
    <>
      {stageState === STAGE_STAGE.unlocked && (
        <StageUnlocked
          $top={unlocked.top}
          $left={unlocked.left}
          width={unlocked.width}
          height={unlocked.height}
          src={images[`main-stage-${number}.png`]}
          onClick={() => {
            handleOnClick();
          }}
        />
      )}
      {stageState === STAGE_STAGE.bossAppealing && (
        <StageUnlockedFadein
          $duration="1.5s" // ปรับเวลาเป็น 1.5 วินาที}
          $top={unlocked.top}
          $left={unlocked.left}
          width={unlocked.width}
          height={unlocked.height}
          src={images[`main-stage-${number}.png`]}
        />
      )}
      {stageState === STAGE_STAGE.locked && (
        <StageLocked
          $top={locked.top}
          $left={locked.left}
          width={locked.width}
          height={locked.height}
          src={images[`main-stage-${number}-locked.png`]}
        />
      )}
      {stageState === STAGE_STAGE.unlocking && (
        <AnimationWithSound
          imageUrl={images['main-unlocking.png']}
          imageTop={unlocking.top}
          imageLeft={unlocking.left}
          imageWidth={unlocking.width}
          imageHeight={unlocking.height}
          playSound={!config.isMutedSound}
        />
      )}
    </>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StageUnlocked = styled(ImgClick)`
  position: absolute;
  left: ${(props) => props.$left}px;
  top: ${(props) => props.$top}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

const StageUnlockedFadein = styled.img`
  position: absolute;
  left: ${(props) => props.$left}px;
  top: ${(props) => props.$top}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  animation: ${fadeIn} ${(props) => props.$duration || '1s'} ease-out;
`;

const StageLocked = styled.img`
  position: absolute;
  left: ${(props) => props.$left}px;
  top: ${(props) => props.$top}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

const StageUnlocking = styled.img`
  position: absolute;
  left: ${(props) => props.$left}px;
  top: ${(props) => props.$top}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default MainStage;
